import React from "react";

import { Box, Typography, TypographyProps } from "@mui/material";

export const Para16Text: React.FC<
  TypographyProps<React.ElementType, { component?: React.ElementType }> & {
    fontWeight?: number;
  }
> = ({ fontWeight = 400, ...otherProps }) => (
  <Typography component="div">
    <Box
      fontSize={16}
      lineHeight={"23.33px"}
      fontWeight={fontWeight}
      letterSpacing={0.5}
    >
      <Typography variant="inherit" component="p" {...otherProps} />
    </Box>
  </Typography>
);
